// ==============================|| THEME CONSTANT ||============================== //

export const APP_DEFAULT_PATH = '/dashboard';
export const DRAWER_WIDTH = 260;
export const MINI_DRAWER_WIDTH = 60;

// PrivacyPal brand fonts (loaded via Google Fonts in index.html)
export const FONT_PRIMARY = `'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif`;
export const FONT_DISPLAY = `'Radley', 'Iowan Old Style', Georgia, serif`;
export const FONT_MONO = `'JetBrains Mono', 'SFMono-Regular', ui-monospace, monospace`;

const config = {
  fontFamily: FONT_PRIMARY
};

export default config;
